/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons200,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons400,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons500,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsPathParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsQueryParams,
} from "../../types/individualPaymentEditorsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons.ts";
import { individualPaymentCouponAppliedViewModelSchema } from "../individualPaymentCouponAppliedViewModelSchema.ts";

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsPathParams>;

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsQueryParamsSchema =
  z
    .object({
      couponId: z.optional(z.coerce.number().int()),
      description: z.optional(z.string()),
    })
    .optional() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons200Schema =
  z.lazy(
    () => individualPaymentCouponAppliedViewModelSchema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons200>;

/**
 * @description Regra de negócio violada
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons500>;

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationResponseSchema =
  z.lazy(
    () =>
      postApiV1IndividualpaymentFinancialPeopleFinancialpersonidCoupons200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidCouponsMutationResponse>;
